





































import { Component, Prop, Vue, Ref } from 'vue-property-decorator';
import { FitKeyboard } from '@tencent/wphk-ui';

/**
   * 带自定义键盘的输入框，支持光标输入
   */
@Component({
  components: {
    FitKeyboard,
  },
})
export default class KeyboardInput extends Vue {
  /** 最大输入长度 */
  @Prop({ default: 8 }) public maxlength!: number;

  /** 键盘类型 */
  @Prop({ default: 'digit' }) public type!: 'number' | 'idcard' | 'digit';

  /** 键盘类型 */
  @Prop({ default: '' }) public placeholder?: string;

  /** 输入提示语位置，在光标左侧还是右侧 */
  @Prop({ default: 'right' }) public placeholderPos?: 'left' | 'right';

  /** 是否禁用金额输入 */
  @Prop({ default: false }) public disabled?: boolean;

  /** 光标输入组件 */
  @Ref('input') public input!: HTMLElement;

  /** 输入前处理，一般用于校验输入字符，返回ture才让输入 */
  @Prop({ default: () => () => true }) public beforeInput?: (
    /** 输入后的完整字符串 */
    newVal: string,
    /** 输入前的完整字符串 */
    oldVal: string,
    /** 当前输入的字符 */
    char: string
  ) => boolean;

  /** 光标位置 */
  public cursorPos = 0;

  /** 输入字符 */
  public chars: string[] = [];

  /** 光标接入标识 */
  public isFocus = false;

  /**
   * 展示已经输入的字符列表，第一位竖杠标识光标开始位置
   */
  public get inputedChars() {
    return ['|'].concat(this.chars);
  }

  /**
   * 是否展示输入键盘
   */
  public get isShowKeyboard() {
    return !this.disabled && this.isFocus;
  }

  /**
   * 是否展示输入提示语
   */
  public get isShowPlaceHolder() {
    return this.placeholder && this.inputedChars.length <= 1;
  }

  /**
   * 点击输入框，设置焦点
   * @param e
   */
  public handleFoucs(e: Event) {
    const target = e.target as HTMLElement;
    const index = Number.parseInt(target.getAttribute('data-index')!, 10);
    // -1表示点击到外框，此时需要将光标设置到最后
    this.setCursorPos(index === -1 ? undefined : index);
    this.focus();
  }

  /**
   * 键盘输入
   * @param obj
   */
  public handleKeyboardTap(obj) {
    const detailVal = obj.detail.value;
    if ('DEL' === detailVal) {
      this.remove();
    } else {
      this.add(detailVal);
    }
  }

  /**
   * 设置光标位置
   * @param pos 光标位置
   */
  public setCursorPos(pos?: number) {
    this.cursorPos = pos === undefined ? this.chars.length : pos;
  }

  /**
   * 添加指定字符
   * @param char
   */
  public add(char: string) {
    if (this.disabled) {
      return;
    }
    // 超过最大输入长度
    if (this.chars.length >= this.maxlength) {
      return;
    }
    // 输入前对字符检测
    if (!this.checkInput(char)) {
      return;
    }
    // 在光标前插入字符
    this.chars.splice(this.cursorPos, 0, char);
    // 光标后移一位
    this.setCursorPos(this.cursorPos + 1);
    // 通知调用方数据变更
    this.notifyValue();
  }

  /**
   * 输入检测
   * @param char
   */
  public checkInput(char: string) {
    if (this.beforeInput) {
      const value = this.chars.join('');
      const cacheChars = value.split('');
      cacheChars.splice(this.cursorPos, 0, char);
      return this.beforeInput(cacheChars.join(''), value, char);
    }
    return true;
  }

  /**
   * 删除一个字符
   */
  public remove() {
    if (this.disabled) {
      return;
    }
    // 光标在起始位置，没有可删除字符
    if (this.cursorPos === 0) {
      return;
    }
    const { cursorPos } = this;
    // 删除光标前的一位字符
    this.chars.splice(cursorPos - 1, 1);
    // 光标前移
    this.setCursorPos(cursorPos - 1);
    this.notifyValue(true);
  }

  /**
   * 光标接入
   */
  public focus() {
    if (!this.disabled) {
      this.isFocus = true;
      this.$emit('focus');
    }
  }

  /**
   * 光标离开
   */
  public blur() {
    if (!this.disabled) {
      this.isFocus = false;
      this.$emit('blur');
    }
  }

  /**
   * 设置输入值
   * @param value
   */
  public setValue(value: string) {
    this.chars = value.split('');
    this.setCursorPos();
    this.notifyValue();
  }

  /**
   * 点击页面其他区域光标离开
   */
  public handleTouchend(e: TouchEvent) {
    let target = e.target as (HTMLElement | null);
    const el = this.input;
    while (target && el) {
      if (target === el) {
        return;
      }
      target = target.parentElement;
    }
    this.blur();
  }

  /**
   * 通知value
   * @param isDelete 是否删除操作
   */
  private notifyValue(isDelete = false) {
    this.$emit('input', this.chars.join(''), isDelete);
  }

  private mounted() {
    document.addEventListener('touchend', this.handleTouchend);
  }

  private destroyed() {
    document.removeEventListener('touchend', this.handleTouchend);
  }
}
